export default __webpack_public_path__ + "static/media/website.770bca27.png";